import axiosIns from '@/plugins/axios'
import { JsonApiListResponse } from '@/api/v2/types/json-api'

type AggregationType = 'ユーザー集計' | 'EodReportClubAggregation'

interface Aggregation {
  id: number
  name: string
}

interface AggregationGroup {
  type: AggregationType
  aggregations: Aggregation[]
}

export interface UserAggregationAssignTemplateAttributes {
  id: number
  name: string
  aggregationCount: number
  aggregations: AggregationGroup[]
}

export interface UserAggregationAssignTemplate {
  id: string
  type: 'userAggregationAssignTemplate'
  attributes: UserAggregationAssignTemplateAttributes
}

type UserAggregationAssignTemplateResponse = {
  data: JsonApiListResponse<UserAggregationAssignTemplate>
}

export default {
  async getUserAggregationAssignTemplates(): Promise<UserAggregationAssignTemplate[]> {
    const response = await axiosIns.get<UserAggregationAssignTemplateResponse>('/v2/employee/user_management/user_aggregation_assign_templates')

    return response.data.data.data
  },
}
